<template>
<div>
  <ul class="progress-indicator large">
    <li
      :class="(index==0 ? 'first ' : '' ) + (activeIndex==index ? 'active ': '') + (index == (steps.length -1)  ? 'last ': '') + (index < activeIndex  ? 'completed ': '')"
      v-for="(step, index) in steps"
      v-bind:key="step"
    >
      <span class="bubble">{{index + 1}}</span>
      {{step}}
    </li>
  </ul>
  <ul class="progress-indicator small">
    <li>
      Passo {{activeIndex+ 1}} de {{steps.length}}: <b>{{steps[activeIndex]}}</b>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: "wizard",
  props: ["steps", "activeIndex"],
};
</script>

<style lang="scss" >
</style>




// WEBPACK FOOTER //
// src/components/Wizard.vue